import { useEffect, useState } from "react";
import Sidebar from "../../components/sidebar/Sidebar";
import Topbar from "../../components/topbar/Topbar";
import style from "./Documento.module.css"
import Alerta from "../../components/alerta/Alerta";
import { Button, Modal } from "react-bootstrap";
import { Form } from "react-bootstrap";
import BotaoNovoAtualizado from "../../components/botaoNovoAtualizado/BotaoNovoAtualizado";
import { Link, useLocation, useNavigate } from "react-router-dom";
import DocumentoApi from "../../services/DocumentoApi";
import { MdDelete, MdClose, MdSearch, MdDangerous } from "react-icons/md";
import { IoCopy } from "react-icons/io5";
import { FaFileDownload } from "react-icons/fa";
import Paginacao from "../../components/paginacao/Paginacao";
import Loader from "../../components/loader/Loader";
import { useIsMobile } from "../../components/useIsMobile/UseIsMobile";

function Documento() {

    const [titulo, setTitulo] = useState();
    const [tituloModal, setTituloModal] = useState("");
    const [urlDocumento, setUrlDocumento] = useState("");
    const [statusTipos, setStatusTipos] = useState([]);

    const [statusdocumento, setstatusdocumento] = useState([]);
    const [tipoArquivoSelecionado, setTipoArquivoSelecionado] = useState("");


    const [Arquivo, setArquivo] = useState();

    //Para abrir e fechar o menu hamburguer 
    const isMobile = useIsMobile();
    const [menuHamburguerAberto, setMenuHamburguerAberto] = useState(!isMobile);

    useEffect(() => {
        setMenuHamburguerAberto(!isMobile);
    }, [isMobile]);

    //Modais para editar e excluir
    const [mostrarModalAdicionar, setMostrarModalAdicionar] = useState(false);
    const [mostarModalDeletar, setMostarModalDelatar] = useState(false);

    //Para rodar a tabela, paginação e filtro
    const [DocumentosSelecionado, setDocumentosSelecionado] = useState([]);
    const [documento, setDocumento] = useState(null);
    const [quantidadeItens, setQuantidadeItens] = useState(0);
    const [nomeTitulo, setNomeTitulo] = useState("");
    const [statusDocumentoEnum, setStatusDocumentoEnum] = useState(0);
    const [nomeTituloFiltro, setTituloFiltro] = useState("");
    const [statusDocumentoEnumFiltro, setStatusDocumentoEnumFiltro] = useState(0);
    const [paginaAtual, setPaginaAtual] = useState(1);

    //Para exibir o alerta
    const [mostrarAlerta, setMostrarAlerta] = useState(false);
    const [mensagemAlerta, setMensagemAlerta] = useState("");
    const [tipoAlerta, setTipoAlerta] = useState("");

    const [loading, setLoading] = useState(false);

    const location = useLocation();

    //Recebe o Id da pessoa a ser editada
    const [pessoaID] = useState(location.state);

    //Função para abrir o modal de adicionar
    const AbrirModalAdicionar = () => {
        setMostrarModalAdicionar(true);
        ResetarModal();
    };

    async function atualizarDocumento(e) {
        e.preventDefault(); // Evita recarregar a página ao enviar o formulário

        // Se quiser um campo separado, altere isso
        if (!Arquivo && !urlDocumento) {
            setMensagemAlerta("É necessário enviar um arquivo ou um link.");
            setTipoAlerta("danger");
            exibirAlerta(true);
            return;
        }

        const formData = new FormData();
        if (Arquivo) {
            formData.append("arquivo", Arquivo);
        }
        formData.append("urlDocumento", urlDocumento);
        formData.append("titulo", tituloModal);
        formData.append("tipoArquivo", tipoArquivoSelecionado);
        formData.append("pessoaId", pessoaID);

        try {
            setLoading(true);
            await DocumentoApi.CarregarDocumento(formData);

            setMensagemAlerta("Documento enviado com sucesso!");
            setTipoAlerta("success");
            exibirAlerta(true);
            setArquivo(null);
            BuscarDocumento();

        } catch (error) {
            setMensagemAlerta(`Erro ao enviar documento: ${error.response?.data || error.message}`);
            setTipoAlerta("danger");
            exibirAlerta(true)
        } finally {
            FecharModal();
            setLoading(false);
        }
    }

    //Função para filtro de busca
    async function FiltroDocumentos() {
        setNomeTitulo(nomeTituloFiltro);
        setStatusDocumentoEnum(statusDocumentoEnumFiltro);
        setPaginaAtual(1);
        BuscarDocumento();

    }

    //Função para resetar  filtro de busca
    async function ResetarDocumentos() {

        setNomeTitulo("");
        setStatusDocumentoEnum(0);
        setStatusDocumentoEnumFiltro(0);
        setTituloFiltro("");
        setPaginaAtual(1);
        BuscarDocumento();
    }

    //Função para resetar  filtro de busca
    async function ResetarModal() {

        setTituloModal("");
        setUrlDocumento("");
        BuscarDocumento();

    }

    //Função para alterar a página
    async function AlterarPagina(paginaNova) {
        setPaginaAtual(paginaNova);
    }
    //Função para abrir o modal de deletar
    const handleClickDeletar = (doc) => {
        setDocumento(doc);
        setMostarModalDelatar(true);
    };

    //Função para obter todos os status tipo documentos
    async function BuscarStatusTipo() {
        try {
            const status = await DocumentoApi.ListarTipoEnum();

            setStatusTipos(status);
        } catch (error) {
            console.error("Erro ao buscar status tipo documento:", error.response.data);
        }
    }

    //Função para obter todos os status documentoenum
    async function BuscarStatusdocumento() {
        try {
            const status = await DocumentoApi.ListarStatusEnum();

            setstatusdocumento(status);
        } catch (error) {
            console.error("Erro ao buscar status documento:", error.response.data);
        }
    }

    async function DeletarDocumento() {
        try {
            setLoading(true);
            await DocumentoApi.RemoverDocumento(documento.documentoID)
            setMensagemAlerta("Documento Deletado com sucesso!");
            setTipoAlerta("success");
            BuscarDocumento();
            exibirAlerta(true);
            FecharModal()
        } catch (error) {
            setMensagemAlerta("Erro ao Deletar o Documento!");
            setTipoAlerta("danger");
            exibirAlerta(true);
        } finally {
            setLoading(false);
        }
    }


    async function Atualizar(doc) {
        try {

            const statusEnum = 3;
            const status = await DocumentoApi.AtualizarStatus(doc, statusEnum);

            setMensagemAlerta("Status atualizado!");
            setTipoAlerta("success");
            exibirAlerta(true);
            BuscarDocumento()

        } catch (error) {

            console.error("Erro ao atualizar documento:", error);
        }
    }


    //Função para obter todos os status de turma
    async function BuscarDocumento() {
        try {
            const documento = await DocumentoApi.ObterDocumentoPorPaginacao(pessoaID.pessoaID, paginaAtual, nomeTitulo, statusDocumentoEnum);

            setQuantidadeItens(documento.quantidadeRegistros);
            setDocumentosSelecionado(documento.registros);

        } catch (error) {

            console.error("Erro ao buscar documento:", error.response.data);
        }
    }

    const BaixarDocumento = async (doc) => {
        try {
            setLoading(true);
            const response = await DocumentoApi.BaixarDocumento(doc);

            const blob = new Blob([response.data], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${doc.titulo || "documento"}.pdf`);
            document.body.appendChild(link);
            link.click();
            link.remove();

            setMensagemAlerta("Documento Baixado com sucesso!");
            setTipoAlerta("success");
            exibirAlerta(true);

        } catch (error) {
            setMensagemAlerta(`Erro ao baixar o documento: ${error.response?.data || error.message}`);
            setTipoAlerta("danger");
            exibirAlerta(true)
        } finally {
            setLoading(false);
        }
    };


    const CopiarParaClipboardAlternativo = async (documentoUrl) => {
        try {
            if (navigator.clipboard && navigator.clipboard.writeText) {
                await navigator.clipboard.writeText(documentoUrl);
            } else {

                // Fallback para navegadores antigos
                const input = document.createElement("input");
                input.value = documentoUrl;
                document.body.appendChild(input);
                input.select();

                document.execCommand("copy");
                document.body.removeChild(input);

            }
            setMensagemAlerta("Link Copiado com sucesso!");
            setTipoAlerta("success");
            exibirAlerta(true);

        } catch (error) {
            console.error("Erro ao copiar o link:", error);

        }
    };


    //Função para o fechar modal
    const FecharModal = () => {
        setMostrarModalAdicionar(false);
        setMostarModalDelatar(false);
        setDocumento(null);
        setUrlDocumento(null);
        setArquivo(null);
        ResetarModal();
    };
    const exibirAlerta = () => {
        setMostrarAlerta(true);
        setTimeout(() => {
            setMostrarAlerta(false);
        }, 3000);
    };

    const totalPaginas = Math.ceil(quantidadeItens / 10); //total de paginas com itens filtrados

    useEffect(() => {
        BuscarDocumento();
        BuscarStatusTipo();
        BuscarStatusdocumento();
    }, [pessoaID, paginaAtual, titulo, statusDocumentoEnum, nomeTitulo]);

    return (

        <Sidebar menuHamburguerAberto={menuHamburguerAberto}
            setMenuHamburguerAberto={setMenuHamburguerAberto}>
            <Topbar menuHamburguerAberto={menuHamburguerAberto} setMenuHamburguerAberto={setMenuHamburguerAberto}>

                <Alerta
                    tipo={tipoAlerta}
                    mensagem={mensagemAlerta}
                    visivel={mostrarAlerta}
                    aoFechar={() => setMostrarAlerta(false)}
                />
                {loading && <Loader />}
                <div className={style.pagina_conteudo}>

                    {/* Cabeçalho da página */}
                    <div className={style.container_cabecalho}>
                        <div>
                            <h4 className={style.cabecalho}>
                                Documentos - <span className={style.nomeMenor}>{pessoaID.nomeCompleto}</span>
                            </h4>
                        </div>


                        <BotaoNovoAtualizado link={AbrirModalAdicionar} />
                    </div>
                    {/* <div>
                        <h4>{pessoaID.nomeCompleto}</h4>
                    </div> */}


                    {/* Filtro de pesquisa */}
                    <div className={style.container_filtro}>
                        <Form.Control
                            type="text"
                            id="hidenTitulo"
                            placeholder="Nome"
                            name="Nome"
                            value={nomeTituloFiltro}
                            onChange={(e) => setTituloFiltro(e.target.value)}
                        />
                        <Form.Select
                            value={statusDocumentoEnumFiltro}
                            onChange={(e) => setStatusDocumentoEnumFiltro(e.target.value)}
                        >
                            <option value="">Status</option>
                            {statusdocumento.map((status) => (
                                <option key={status.id} value={status.id}>
                                    {status.nome}

                                </option>
                            ))}
                        </Form.Select>
                        <div className={style.container_filtro2} >

                            <Button onClick={FiltroDocumentos} id={style.botao_buscar}><MdSearch /> Buscar
                            </Button>

                            <Button onClick={ResetarDocumentos} id={style.botao_resetar}><MdClose /> Limpar
                            </Button>
                        </div>

                    </div>

                    <div className={style.container_tabela_paginacao}>
                        <div className={style.tabela_responsiva}>
                            <table className={style.container_tabela}>
                                <thead>
                                    <tr>
                                        <th>Nome</th>
                                        <th>Tipo </th>
                                        <th>Ultimo Envio</th>
                                        <th>Status</th>
                                        <th className={style.coluna_acoes}>Ações</th>
                                    </tr>
                                </thead>
                                <tbody>

                                    {DocumentosSelecionado?.map((doc) => (

                                        <tr className={style.tabela_corpo} key={doc.id}>
                                            <td title={doc.titulo}>{doc.titulo}</td>

                                            <td title={statusTipos.find(s => s.id === doc.statusTipoArquivo)?.nome}>{statusTipos.find(s => s.id === doc.statusTipoArquivo)?.nome}</td>


                                            <td title={doc.dataEnvio}>{new Date(doc.dataEnvio).toLocaleDateString('pt-BR', {
                                                day: '2-digit',
                                                month: '2-digit',
                                                year: 'numeric'
                                            })}{' '}

                                            </td>
                                            <td title={statusdocumento.find(s => s.id === doc.statusDocumentoEnum)?.nome}>
                                                <span
                                                    className={`badge ${statusdocumento.find(s => s.id === doc.statusDocumentoEnum)?.nome === "Pendente"
                                                        ? "bg-warning"
                                                        : statusdocumento.find(s => s.id === doc.statusDocumentoEnum)?.nome === "Assinado"
                                                            ? "bg-success"
                                                            : statusdocumento.find(s => s.id === doc.statusDocumentoEnum)?.nome === "Rejeitado"
                                                                ? "bg-danger"
                                                                : "bg-secondary"
                                                        }`}
                                                    style={{ fontSize: "12px", padding: "5px 12px" }}
                                                >
                                                    {statusdocumento.find(s => s.id === doc.statusDocumentoEnum)?.nome}
                                                </span>
                                            </td>

                                            <td className={style.coluna_acoes}>


                                                {doc.statusTipoArquivo !== 2 && (
                                                    <Link
                                                        title="Baixar"
                                                        onClick={() => BaixarDocumento(doc.documentoID)}
                                                        className={style.botao_baixar}
                                                    >
                                                        <FaFileDownload />
                                                    </Link>
                                                )}

                                                {doc.statusTipoArquivo === 2 && (
                                                    <Link
                                                        title="Copiar"
                                                        onClick={() => CopiarParaClipboardAlternativo(doc.urlDocumento)}
                                                        className={style.botao_baixar}
                                                    >
                                                        <IoCopy />
                                                    </Link>
                                                )}

                                                <Link
                                                    title="Deletar"
                                                    onClick={() => handleClickDeletar(doc)}
                                                    className={style.botao_deletar}
                                                >
                                                    <MdDelete />
                                                </Link>
                                                <Link
                                                    title="Rejeitar"
                                                    onClick={() => Atualizar(doc.documentoID)}
                                                    className={style.botao_deletar}
                                                >
                                                    <MdDangerous />
                                                </Link>
                                            </td>

                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        <Paginacao
                            id={style.configuracao_paginacao}
                            paginaAtual={paginaAtual}
                            totalPages={totalPaginas}
                            onPageChange={(novaPagina) => AlterarPagina(novaPagina)}
                        />
                    </div>
                    <Modal show={mostrarModalAdicionar} onHide={FecharModal}>
                        <Modal.Header closeButton>
                            <Modal.Title>Criar Documento</Modal.Title>
                        </Modal.Header>

                        <Modal.Body>
                            <Form.Group controlId="Titulo" className="mb-3">
                                <Form.Label>Título</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Título"
                                    value={tituloModal}
                                    onChange={(e) => setTituloModal(e.target.value)}
                                />
                            </Form.Group>

                            {/* Tipo de Arquivo */}
                            <Form.Group controlId="formStatusTipoArquivo" className="mb-3">
                                <Form.Label>Tipo do Arquivo</Form.Label>
                                <Form.Control
                                    as="select"
                                    value={tipoArquivoSelecionado}
                                    onChange={(e) => setTipoArquivoSelecionado(e.target.value)}
                                    required
                                >
                                    <option value="">Selecione a modalidade</option>
                                    {statusTipos
                                        .filter((status) => status.id !== 3 && status.id !== 4)
                                        .map((status) => (
                                            <option key={status.id} value={status.id}>
                                                {status.id === 2 ? "Link" : status.nome}
                                            </option>
                                        ))}
                                </Form.Control>
                            </Form.Group>

                            {tipoArquivoSelecionado === '2' && (
                                <Form.Group controlId="UrlDocumento" className="mb-3">
                                    <Form.Label>Link</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Informe o link do documento"
                                        value={urlDocumento}
                                        onChange={(e) => setUrlDocumento(e.target.value)}
                                    />
                                </Form.Group>
                            )}

                            {tipoArquivoSelecionado === '1' && (
                                <Form.Group controlId="nome" className="mb-3">
                                    <Form.Label>Arquivo</Form.Label>
                                    <Form.Control
                                        type="file"
                                        onChange={(e) => setArquivo(e.target.files[0])}
                                    />
                                </Form.Group>
                            )}
                        </Modal.Body>


                        <Modal.Footer>
                            <Button variant="secondary " onClick={FecharModal}>
                                Cancelar
                            </Button>
                            <Button onClick={atualizarDocumento}>
                                Salvar
                            </Button>
                        </Modal.Footer>
                    </Modal>
                    {/* Modal de confirmação */}
                    <Modal show={mostarModalDeletar} onHide={FecharModal}>
                        <Modal.Header closeButton>
                            <Modal.Title>Confirmar</Modal.Title>
                        </Modal.Header>

                        <Modal.Body>
                            Tem certeza que deseja deletar o Documento{" "}
                            {documento?.titulo}?
                        </Modal.Body>

                        <Modal.Footer>
                            <Button variant="secondary" onClick={FecharModal}>
                                Cancelar
                            </Button>
                            <Button variant="danger" onClick={DeletarDocumento}>
                                Deletar
                            </Button>
                        </Modal.Footer>
                    </Modal>
                </div>
            </Topbar>
        </Sidebar>
    )
}
export default Documento;